import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { forwardRef, memo } from 'react';
import { useDatePickerMonthYearSelectorClassNames } from './hooks/useDatePickerMonthYearSelectorClassNames';
import { useDatePickerMonthYearSelector } from './hooks/useDatePickerMonthYearSelector';
import { DatePickerMonthYearSelectorRoot, DatePickerMonthYearSelectorScroll, DatePickerMonthYearSelectorList, DatePickerMonthYearSelectorYear, DatePickerMonthYearSelectorYearTitle, DatePickerMonthYearSelectorMonthList, DatePickerMonthYearSelectorMonth } from './style';
import { DATE_PICKER_MONTH_YEAR_SELECTOR_CLASS_PREFIX } from './constants';
/**
 * @internal
 */
export var DatePickerMonthYearSelector = memo(forwardRef(function DatePickerMonthYearSelector(_ref, ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var classNameComponents = useDatePickerMonthYearSelectorClassNames(DATE_PICKER_MONTH_YEAR_SELECTOR_CLASS_PREFIX, className);
  var _useDatePickerMonthYe = useDatePickerMonthYearSelector(props, ref),
    rootProps = _useDatePickerMonthYe.rootProps,
    scrollProps = _useDatePickerMonthYe.scrollProps,
    listProps = _useDatePickerMonthYe.listProps,
    yearTitleProps = _useDatePickerMonthYe.yearTitleProps,
    monthProps = _useDatePickerMonthYe.monthProps,
    months = _useDatePickerMonthYe.months,
    yearRange = _useDatePickerMonthYe.yearRange,
    displayedYear = _useDatePickerMonthYe.displayedYear,
    displayedMonth = _useDatePickerMonthYe.displayedMonth,
    openYear = _useDatePickerMonthYe.openYear,
    isMonthAllowed = _useDatePickerMonthYe.isMonthAllowed;
  return React.createElement(DatePickerMonthYearSelectorRoot, _objectSpread(_objectSpread({}, rootProps), {}, {
    className: classNameComponents.Root
  }), React.createElement(DatePickerMonthYearSelectorScroll, _objectSpread(_objectSpread({}, scrollProps), {}, {
    className: classNameComponents.Scroll
  }), React.createElement(DatePickerMonthYearSelectorList, _objectSpread(_objectSpread({}, listProps), {}, {
    className: classNameComponents.List
  }), yearRange.map(function (year) {
    return React.createElement(DatePickerMonthYearSelectorYear, {
      className: classNameComponents.Year,
      key: year
    }, React.createElement(DatePickerMonthYearSelectorYearTitle, _objectSpread(_objectSpread({}, yearTitleProps), {}, {
      className: classNameComponents.YearTitle,
      "data-year": year
    }), year), openYear === year && React.createElement(DatePickerMonthYearSelectorMonthList, {
      className: classNameComponents.MonthList
    }, months.map(function (monthName, monthNumber) {
      var isAllowed = Boolean(isMonthAllowed === null || isMonthAllowed === void 0 ? void 0 : isMonthAllowed(year, monthNumber));
      return React.createElement(DatePickerMonthYearSelectorMonth, _objectSpread(_objectSpread({}, monthProps), {}, {
        className: classNameComponents.Month,
        key: monthName,
        "data-month": monthNumber,
        "data-year": year,
        selected: monthNumber === displayedMonth && year === displayedYear,
        disabled: !isAllowed
      }), monthName);
    })));
  }))));
}));
DatePickerMonthYearSelector.displayName = DATE_PICKER_MONTH_YEAR_SELECTOR_CLASS_PREFIX;